// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ksUq","location":"Header_location__2OEh4"};